import { Button } from "@mui/material";
import { DrawerLayout } from "@/components/common/drawerLayout";
import ClientForm from "@/components/serviceFlow/clientDetails/forms/clientForm";
import useCreateClientForm from "@/hooks/serviceFlow/clients/useCreateClientForm";
import { CreateClientInputs } from "@/views/serviceFlow/clients/createClientView";
import { ClientForAppointmentCreation } from "../../common/clientSection";
import { DrawerStep } from "./multiProviderAppointmentDrawer";
import { useMultiProviderAppointmentDrawerContext } from "./multiProviderAppointmentDrawerContext";

export const MultiProviderAppointmentDrawerClientForm = ({
  onSetDrawerStep,
}: {
  onSetDrawerStep: (step: DrawerStep) => void;
}) => {
  const { setClient, isRebooking } = useMultiProviderAppointmentDrawerContext();

  const onSubmitSuccess = (
    clientId: string,
    details: Omit<ClientForAppointmentCreation, "id">
  ) => {
    setClient({
      id: clientId,
      ...details,
    });
    onSetDrawerStep(DrawerStep.DEFAULT);
  };

  const { control, setValue, trigger, onSubmit, loading, handleSubmit } =
    useCreateClientForm({
      onSubmitSuccess,
    });

  return (
    <DrawerLayout
      headerProps={{
        title: isRebooking ? "Rebook client" : "Create new client",
      }}
      content={
        <ClientForm<CreateClientInputs>
          control={control}
          setValue={setValue}
          trigger={trigger}
        />
      }
      actions={
        <>
          <Button
            onClick={() => onSetDrawerStep(DrawerStep.DEFAULT)}
            variant="outlined"
            sx={{ flex: 1 }}
            size="small"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit(onSubmit)}
            variant="contained"
            sx={{ flex: 1 }}
            size="small"
            disabled={loading}
          >
            Create client
          </Button>
        </>
      }
    />
  );
};
